import { Component } from '@angular/core';
import { DialogComponent } from '@tytapp/common';

@Component({
  selector: 'app-test-dialog',
  templateUrl: './test-dialog.component.html',
  styleUrls: ['./test-dialog.component.scss']
})
export class TestDialogComponent extends DialogComponent {
  init(message : string) {
    this.message = message;
  }

  message : string;

  get pageComponentId() {
    return 'test';
  }

}
